import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'ceres-new-release-dialog',
    templateUrl: './new-release-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NewReleaseDialogComponent {
    private readonly dialogRef = inject(MatDialogRef<NewReleaseDialogComponent>);
    private readonly router = inject(Router);
    public goToReleaseNotes(): void {
        this.dialogRef.close();
        void this.router.navigate(['/release-notes']);
    }
}
